<template>
  <div>
    <!-- Dropdown Trigger -->
    <a class="dropdown-trigger" data-target="dropdown1">
      {{ title }}
      <i class="material-icons" style="margin-left: 10px;">expand_more</i>
    </a>

    <!-- Dropdown Structure -->
    <ul id="dropdown1" class="dropdown-content">
      <slot name="itens-drop">
        <li>
          <a>item</a>
        </li>
      </slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    title: {
      type: String,
      default: "Title drop"
    }
  },
  data: () => ({
    instance: {}
  }),
  mounted() {
    this.instance = M.Dropdown.init(
      this.$el.querySelector(".dropdown-trigger")
    );
  },
  beforeDestroy() {
    this.instance.destroy();
  }
};
</script>

<style lang="scss" scoped>
.dropdown-trigger {
  display: flex;
  min-width: 130px;
  justify-content: flex-end;

  color: #fff;
}
#dropdown1 {
  min-height: 64px;
  li:not(.divider) {
    min-height: 64px;
    a {
      width: 100%;
      text-align: center;
      line-height: 64px;
      padding: 0 16px;
    }
  }
}
</style>
